import { Telemetry } from '@syncfusion/ej2-base';

/**
 * Syncfusion 35 ships a telemetry client that is enabled by default and posts
 * session and machine identifiers to Azure Application Insights. It is also
 * what breaks short-lived Node processes: the client starts a six-second flush
 * interval and a five-minute cleanup interval, and only `dispose()` clears
 * them, which nothing calls. A process that should exit on its own — the unit
 * test runner, a build worker — never drains its event loop and hangs.
 *
 * The app disables telemetry here, and `test:unit` preloads this module with
 * `--import` so the test process starts already disabled. Keep it a side-effect
 * import and keep it first: it must run before any Syncfusion component is
 * constructed.
 */
Telemetry.disable();
